import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import axios from 'axios';
import { img_500, unavailable, unavailableLandscape } from '../../Config';
import { Button } from '@material-ui/core';
import YouTubeIcon from '@material-ui/icons/YouTube';
import './ItemModal.css';
import {Carousel} from '../Carousel/Carousel';

const useStyles = makeStyles((theme) => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    backgroundColor: "#39445a",
    border: '1px solid #000',
    borderRadius: 10,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(1, 1, 3),
    width: "90%",
    height: "80%",
  },
}));

export default function ItemModal({ children, id, media }) {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const [content, setContent] = useState([]);
  const [video, setVideo] = useState();

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const fetchData = async () => {
    const { data } = await axios.get(`
    https://api.themoviedb.org/3/${media}/${id}?api_key=${process.env.REACT_APP_API_KEY}&language=en-US`);
    setContent(data);
  }

  const fetchVideo = async () => {
    const { data } = await axios.get(`
    https://api.themoviedb.org/3/${media}/${id}/videos?api_key=${process.env.REACT_APP_API_KEY}&language=en-US`);

    setVideo(data.results[0]?.key);
  }

  useEffect(() => {
    fetchData();
    fetchVideo();
    // eslint-disable-next-line
  },[])


  return (
    <>
      <div className="card" style={{cursor: "pointer"}} onClick={handleOpen}>
        {children}
      </div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>{content && (
          <div className={classes.paper}>
          <div className="content-modal">
            {<img  alt={content.name || content.title} src={content.poster_path ? 
            `${img_500}/${content.poster_path}`
            : unavailable } className='potrait'/>}
            {
              <img  alt={content.name || content.title} src={content.poster_path ? 
                `${img_500}/${content.backdrop_path}`
                : unavailableLandscape }
                className='landscape'/>
            }
            <div className='content-about'>
              <span className='content-title'>
              {content.name || content.title}(
                {
                  (content.first_air_date ||
                    content.release_date ||
                    "------").substring(0,4)
                }
              )
              </span>
              {content.tagline &&
                (<i className='tagline'>{content.tagline}</i>)
              }
              <span className='content-description'>
                {content.overview}
              </span>
              <div>
                <Carousel id={id} media={media}/>
              </div>
              <Button
              variant='contained'
              startIcon={<YouTubeIcon/>}
              color='secondary'
              target='__blank'
              href={`https://www.youtube.com/watch?v=${video}`}
              >Watch the trailer</Button>
            </div>
          </div>
          </div>
        )}
        </Fade>
      </Modal>
    </>
  );
}
